module.exports = __webpack_public_path__ + "img/puroak.icon.bdf.asset.cf956f14.svg";